import angular from 'angular';
import moment from 'moment';

import modalSpecialSchedules from './unit-datail-modals/modal-special-schedules.html'
import modalApprovalSpecialSchedules from './unit-datail-modals/modal-approval-special-schedules.html'

const weedDays = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];

let UnitDetailController = function ($filter, $mdDialog, $scope, $state, City, Differential, NgMap, Region, Service, State, Toast, Unit, UnitDetail, TimeTitleService) {
  let $ctrl = this;

  $ctrl.isManager = $scope.$root.user.access_group.special_rule.includes('MANAGER') || $scope.$root.user.access_group.is_super;

  const responseMessages = responsePackage => {
    try {
      return {
        syncHoursGMB: responsePackage.response.itWorked
          ? $filter('translate')('toast-success-hours-sync')
          : $filter('translate')('toast-error-houts-sync'),
        approvalAttendanceHour: responsePackage.response.itWorked
          ? $filter('translate')('toast-success-approval-attendance-hour')
          : $filter('translate')('toast-error-approval-attendance-hour'),
        approvedSpecialHours: responsePackage.response.itWorked
          ? $filter('translate')('toast-success-approved-special-hours')
          : $filter('translate')('toast-error-approved-special-hours'),
        removeSpecialHours: responsePackage.response.itWorked
          ? $filter('translate')('toast-success-remove-special-hours')
          : $filter('translate')('toast-error-remove-special-hours'),
        syncSpecialHours: responsePackage.response.itWorked
          ? $filter('translate')('toast-success-sync-special-hours')
          : $filter('translate')('toast-error-sync-special-hours')
      }[responsePackage.action]
    } catch (error) {
      sessionStorage.removeItem('responsePackage');
    }
  }

  const responsePackage = sessionStorage.responsePackage ? JSON.parse(sessionStorage.responsePackage) : null;
  if (responsePackage) {
    if (responsePackage.action != 'getLocationsGMB') {
      if (responsePackage.response.itWorked) {
        Toast.success(responseMessages(responsePackage));
      } else {
        Toast.error(responseMessages(responsePackage));
      }
    }
    if (responsePackage.callback) {
      setTimeout(() => {
        $ctrl[responsePackage.callback]()
      }, 7000);
    }
    sessionStorage.removeItem('responsePackage');
  }

  $ctrl.id = $state.params.id;
  $ctrl.unit;
  $ctrl.reviewerName;
  $ctrl.unitRequest;
  $ctrl.changeScheduleLoading = false;
  $ctrl.pendingRequests = false;
  $ctrl.new_opening_hour = {};
  $ctrl.schedules = [];
  $ctrl.approvalSchedules = [];
  $ctrl.approvalSpecialSchedules = [];
  $ctrl.requestChangeScheduleObservation = null;
  $ctrl.modalApprovalSpecialSchedulesActived = false;
  $ctrl.newsItems = sessionStorage.locationsGMB ? JSON.parse(sessionStorage.locationsGMB) : [];
  $ctrl.schedulesGMB = [];
  $ctrl.events = [];
  $ctrl.editingSpecialHour = false;
  $ctrl.scheduleTitles = [
    "Horário de Funcionamento",
    "Horário de Coleta",
    "Horário de entrega de Resultados",
    "Horário de Coleta Exame Covid-19",
    "Horário de Vacinas",
    "Horário de Coleta Espermograma",
    "Atendimento Ultrassonografia",
    "Atendimento Tomografia",
    "Atendimento Ressonância",
    "Horário de Imagem",
  ];

  var defaultUnitHour = {
    schedule_title_id: "",
    name: $filter('translate')('unit-detail-default-unit-opening-hour-text'),
    value: '',
    type: 'UNIT'
  };

  angular.extend($ctrl, {
    addOpeningHour,
    clearForm,
    handleSave,
    handleDelete,
    isIdInList,
    onChangeState,
    toggleItemInList,
    removeOpeningHour,
    replaceSpecialChar,
    requestChangeSchedule,
    syncHoursGMB,
    querySearch,
    selectedNewsItemChange,
    saveEvent
  });

  activate();

  async function activate() {
    angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
    angular.element(document.querySelector('#syncHoursGMB')).on('click', syncHoursGMB);
    angular.element(document.querySelector('#addSpecialSchedules')).on('click', toggleModalSpecialSchedules);
    angular.element(document.querySelector('#subTitleSchedules')).on('click', toggleModalApprovalSpecialSchedules);
    getTimeTitleList()

    $scope.$on('mapInitialized', function (event, map) {
      let center = map.getCenter();
      google.maps.event.trigger(map, 'resize');
      map.setCenter(center);
    });

    clearForm();

    $ctrl.uiState = 'LOADING';

    loadDomainResources()
      .then(result => {
        $ctrl.differentials = result[0];
        $ctrl.regions = result[1];
        $ctrl.services = result[2];
        $ctrl.states = result[3];

        loadResource($ctrl.id);
      })
      .catch(err => {
        $ctrl.uiState = 'ERROR';
      });

    await UnitDetail.getRequestChangeSchedule()
      .then(data => {
        if (data.length) {
          let approvalSchedules = data[0].attendance_hour_approvals;
          $ctrl.reviewerName = approvalSchedules[0].author.name;
          $ctrl.approvalSchedules = approvalSchedules.slice(approvalSchedules.length - 7);
          $ctrl.modalApprovalSpecialSchedulesActived = true;
          setTimeout(() => {
            $ctrl.pendingRequests = true;
            toggleModalApprovalSpecialSchedules();
          }, 10000);
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  function querySearch(searchText) {
    searchText = searchText.toLowerCase();

    let results = _.filter($ctrl.newsItems, newsItem => {
      return newsItem.location_name.toLowerCase().indexOf(searchText) > -1;
    });

    return results;
  }

  function selectedNewsItemChange(newsItem) {
    if (newsItem) {
      $ctrl.locationSelected_id = newsItem
    }
  }

  function getAttendanceHour(unitData) {
    UnitDetail.getAttendanceHour($ctrl.id)
      .then(data => {
        $ctrl.schedules = [];
        let schedulesAux = data;
        weedDays.forEach(day => {
          if (schedulesAux.map(el => el.week_day).indexOf(day) < 0) {
            schedulesAux.push({
              week_day: day === 'Sabado' ? 'Sábado' : day,
              is_open: false,
              start_hour: '08:00',
              end_hour: '18:00',
              unit_id: unitData.id,
              unit: unitData
            })
          }
        })
        weedDays.forEach(day => {
          schedulesAux.forEach(dayAux => {
            if (day === dayAux.week_day) {
              $ctrl.schedules.push(dayAux);
            }
          });
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  function addOpeningHour() {
    $ctrl.unit.opening_hours.push({
      schedule_title_id: '',
      value: '',
      type: 'OTHER'
    });
  }

  function syncHoursGMB() {
    $ctrl.uiState = 'LOADING';
    sessionStorage.setItem('requestPackage', JSON.stringify({
      redirectUrl: 'unit.edit',
      action: 'syncHoursGMB',
      params: {
        id: $ctrl.id
      },
      payload: $ctrl.id
    }));
    $state.go('unit.authentication');
  }

  function getLocationsGMB() {
    $ctrl.uiState = 'LOADING';
    sessionStorage.setItem('requestPackage', JSON.stringify({
      redirectUrl: 'unit.edit',
      action: 'getLocationsGMB',
      params: {
        id: $state.params.id
      }
    }));
    $state.go('unit.authentication');
  }

  function clearForm(form) {
    $ctrl.myImage = '';
    $ctrl.fileName = undefined;
    $ctrl.unit = {
      city: {},
      opening_hours: [defaultUnitHour],
      differentials: [],
      services: [],
      image_base64: '',
      image_uri: ''
    };

    if (form) {
      form.$setPristine();
      form.$setUntouched();
    }
  }

  function handleDelete(unit, event) {
    let confirm = $mdDialog.confirm()
      .textContent($filter('translate')('unit-detail-delete-confirm-text'))
      .ariaLabel($filter('translate')('unit-detail-delete-confirm-text'))
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    $mdDialog.show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Unit
          .destroy(unit)
          .then(response => {
            Toast.success($filter('translate')('unit-detail-delete-success'));
            $ctrl.deleting = false;
            $state.go('unit.list')
          })
          .catch(err => {
            Toast.error($filter('translate')('common-server-error'));
            console.log('err:', err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {
      });
  }

  function handleSave(form, unit) {
    unit.is_priority_special_hours = $ctrl.prioritizeSpecialHour ? 1: 0

    if ($ctrl.requestChangeScheduleObservation) {
      if (!form.$valid) {
        Toast.error($filter('translate')('common-form-incomplete'));
        return;
      }
    }
    unit.opening_hours.forEach(item => {
      if(isNaN(item.schedule_title_id)){ 
        item.name = item.schedule_title_id
        item.schedule_title_id = null
      }
    })

    if ($ctrl.locationSelected_id) {
      unit.gmb_id = $ctrl.locationSelected_id.location_id;
    } else if ($ctrl.locationSelected_id2) {
      unit.gmb_id = $ctrl.locationSelected_id2.location_id;
    } else {
      unit.gmb_id = null;
    }

    $ctrl.saving = true;
    Unit
      .save(unit)
      .then(response => {
        Toast.success($filter('translate')('unit-detail-save-success'));
        $ctrl.unit = response;
        $state.go('unit.list')
      })
      .catch(err => {
        Toast.error($filter('translate')('common-save-error'));
        $ctrl.saving = false;
      })
      .finally(()=>{
        if($ctrl.unit.id){
          saveEvent($ctrl.events)
        }
      })
  }

  function saveEvent(data){
    $ctrl.saving = true;
    let content
    if(data.length) {
      content = data.map(event => {
        return event.special_hours
      })
      content.forEach(event => {
        event.special_hours.forEach((item) => {
          item.flag = Number(item.flag)
        })
      })
    }
    else if (data.special_hours) {
      data.special_hours.forEach((item) => {
        item.flag = Number(item.flag)
      })
      content = data.id ? data : [data]
    }

    Unit.saveEvent(content, $ctrl.id || $ctrl.unit.id).then(resp => {
      if(!data.special_hours){
        $state.go('unit.list');
      }
      else {
        loadSpecialHours($ctrl.id)
      }
    }).catch(()=>{
      Toast.error($filter('translate')('common-save-error'));
    }).finally(() => {
      $ctrl.saving = false;
    })

  }

  function isIdInList(list, id) {
    return _.find(list, {id: id});
  }

  function onChangeState(stateId) {
    $ctrl.unit.city_id = undefined;
    $ctrl.loadingCities = true;

    City
      .index({
        state_id: stateId,
        limit: 10000
      })
      .then(cities => {
        $ctrl.cities = cities;
        $ctrl.loadingCities = false;
      })
      .catch(err => {
        $ctrl.loadingCities = false;
      });
  }

  function toggleItemInList(list, item) {
    if (_.find(list, {id: item.id})) {
      _.remove(list, {id: item.id});
    } else {
      list.push(item);
    }
  }

  function removeOpeningHour(item) {
    let confirm = $mdDialog.confirm()
      .textContent($filter('translate')('unit-detail-remove-opening-hour-confirm-text'))
      .ariaLabel($filter('translate')('unit-detail-remove-opening-hour-confirm-text'))
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    $mdDialog.show(confirm)
      .then(() => {
        if (item.id) {
          _.remove($ctrl.unit.opening_hours, {id: item.id});
        } else {
          _.remove($ctrl.unit.opening_hours, {$$hashKey: item.$$hashKey});
        }
      })
      .catch(() => {
      });
  }

  // Local functions

  function handleFileSelect(event) {
    let file = event.currentTarget.files[0];

    if (!file) {
      return;
    }

    let reader = new FileReader();
    reader.onload = function (event) {
      $ctrl.myImage = event.target.result;
      $scope.$apply();
      $ctrl.fileName = file.name;
      showCropDialog(event);
    };

    reader.readAsDataURL(file);
  }

  function showCropDialog(event) {
    $mdDialog.show({
      controller: DialogController,
      targetEvent: event,
      template:
        '<md-dialog aria-label="Image cropper dialog" class="sb-ui-cropper-dialog">' +
        '  <md-dialog-content>' +
        '    <div layout="row" layout-align="center center" ng-show="!isDoneLoading">' +
        '      <md-progress-linear md-mode="indeterminate"></md-progress-linear>' +
        '    </div>' +
        '' +
        '    <ui-cropper' +
        '      ng-show="isDoneLoading === true"' +
        '      on-load-done="isDoneLoading = true"' +
        '      image="myImage"' +
        '      area-type="rectangle"' +
        '      aspect-ratio="1.6744186047"' +
        '      init-max-area="true"' +
        '      chargement="loadingText"' +
        '      result-image-size="{w: 720,h: 430}"' +
        '      result-image="image_base64" canvas-scalemode="true">' +
        '    </ui-cropper>' +
        '  </md-dialog-content>' +
        '  <md-dialog-actions' +
        '     ng-show="isDoneLoading === true">' +
        '    <md-button ng-click="cancel()">' +
        '      Cancelar' +
        '    </md-button>' +
        '    <md-button ng-click="cropImage(image_base64)" class="md-accent">' +
        '      Feito' +
        '    </md-button>' +
        '  </md-dialog-actions>' +
        '</md-dialog>',
      bindToController: true,
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      fullscreen: false
    })
      .then(function (image_base64) {
        // $ctrl.image_base64 = image_base64;
        $ctrl.unit.image_base64 = image_base64;
        $ctrl.myImage = '';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
  }

  function DialogController($scope, $mdDialog, $filter, eventData, idx) {
    "ngInject";
    $scope.loadingText = $filter('translate')('common-loading');
    $scope.myImage = $ctrl.myImage;
    $scope.minDate = new Date()

    // $scope.image_base64 = $ctrl.image_base64;
    $scope.labelDays = {
      1: 'Domingo',
      2: 'Segunda',
      3: 'Terça',
      4: 'Quarta',
      5: 'Quinta',
      6: 'Sexta',
      7: 'Sábado'
    };
    $ctrl.unit.image_base64 = $ctrl.unit.image_base64;
    $scope.isManager = $ctrl.isManager;
    $scope.unit = $ctrl.unit;
    $scope.reviewerName = $ctrl.reviewerName;
    $scope.isEditing = (eventData && eventData.id)
    $scope.schedulesGMB = (eventData && eventData.special_hours) ? angular.copy(eventData.special_hours) : [{
      date: new Date(),
      flag: false,
      description: ''
    }];
    $scope.eventName = eventData && eventData.name ? eventData.name : ''

    $scope.reasonRejection = '';

    $scope.reasonRejectionSpecialSchedules = '';

    $scope.isRejectSchedulesChange = false;

    $scope.approvalSchedules = $ctrl.approvalSchedules;

    $scope.approvalSpecialSchedules = $ctrl.approvalSpecialSchedules;

    $scope.modalBody1 = true;
    $scope.modalBody2 = true;

    if (!$scope.approvalSchedules.length) {
      $scope.modalBody1 = false;
    }

    if (!$scope.approvalSpecialSchedules.length) {
      $scope.modalBody2 = false;
    }

    $scope.moment = moment;

    $scope.toggleRejectSchedulesChange = function () {
      angular.element(document.querySelector('.schedules-reject'))[0].style.display = 'initial';
      angular.element(document.querySelector('.my-md-dialog-actions'))[0].style.display = 'none';
      angular.element(document.querySelector('.my-md-dialog-actions-reject'))[0].style.display = 'initial';
    }

    $scope.buttonBack = function () {
      angular.element(document.querySelector('.schedules-reject'))[0].style.display = 'none';
      angular.element(document.querySelector('.my-md-dialog-actions'))[0].style.display = 'initial';
      angular.element(document.querySelector('.my-md-dialog-actions-reject'))[0].style.display = 'none';
    }

    $scope.toggleRejectSpecialSchedulesChange = function () {
      angular.element(document.querySelector('.special-schedule > .schedules-reject'))[0].style.display = 'initial';
      angular.element(document.querySelector('.special-schedule > .my-md-dialog-actions'))[0].style.display = 'none';
      angular.element(document.querySelector('.special-schedule > .my-md-dialog-actions-reject'))[0].style.display = 'initial';
    }

    $scope.buttonBackSpecialSchedules = function () {
      angular.element(document.querySelector('.special-schedule > .schedules-reject'))[0].style.display = 'none';
      angular.element(document.querySelector('.special-schedule > .my-md-dialog-actions'))[0].style.display = 'initial';
      angular.element(document.querySelector('.special-schedule > .my-md-dialog-actions-reject'))[0].style.display = 'none';
    }

    $scope.approvedAttendanceHour = function () {
      $ctrl.uiState = 'LOADING';
      sessionStorage.setItem('requestPackage', JSON.stringify({
        redirectUrl: 'unit.edit',
        action: 'approvalAttendanceHour',
        params: {
          id: $ctrl.id
        },
        payload: $ctrl.id
      }));
      $state.go('unit.authentication');
      $mdDialog.cancel();
    }

    $scope.approvedSpecialHours = function () {
      $ctrl.uiState = 'LOADING';
      sessionStorage.setItem('requestPackage', JSON.stringify({
        redirectUrl: 'unit.edit',
        action: 'approvedSpecialHours',
        params: {
          id: $ctrl.id
        },
        payload: $ctrl.id
      }));
      $state.go('unit.authentication');
      $mdDialog.cancel();
    }

    $scope.syncSpecialHours = function () {
      $ctrl.uiState = 'LOADING';
      sessionStorage.setItem('requestPackage', JSON.stringify({
        redirectUrl: 'unit.edit',
        action: 'syncSpecialHours',
        params: {
          id: $ctrl.id
        },
        payload: $ctrl.id,
        callback: 'toggleModalSpecialSchedules'
      }));
      $state.go('unit.authentication');
      $mdDialog.cancel();
    }

    $scope.rejectAttendanceHour = function () {
      Unit.rejectAttendanceHour({
        id: $ctrl.id, data: {
          review_reason: $scope.reasonRejection,
        }
      }).then(data => {
        Toast.success($filter('translate')('toast-success-reject-attendance-hour'));
        $mdDialog.cancel();
      }).catch(err => {
        Toast.error($filter('translate')('toast-error-reject-attendance-hour'));
        $mdDialog.cancel();
      })
    }

    $scope.rejectSpecialHours = function () {
      UnitDetail.rejectSpecialHours({
        id: $ctrl.id, data: {
          review_reason: $scope.reasonRejectionSpecialSchedules,
          reviewer_id: $scope.$root.user.id
        }
      }).then(data => {
        Toast.success($filter('translate')('toast-success-reject-special-hours'));
        $mdDialog.cancel();
      }).catch(err => {
        Toast.error($filter('translate')('toast-error-reject-special-hours'));
        $mdDialog.cancel();
      })
    }

    $scope.removeSpecialHours = function (idx, specialHour) {
      if(specialHour.id){
        $ctrl.saving = true;
        Unit.removeSpecialHour(specialHour.id)
        .then((resp)=>{
          $mdDialog.cancel()
        })
        .catch(() => {
          Toast.error($filter('translate')('common-save-error'));
        })
        .finally(()=>{
          $ctrl.saving = false;
          loadSpecialHours($ctrl.id)
        })
      }
      else{
        $scope.schedulesGMB.splice(idx, 1)
      }
    }

    $scope.addNewSchedules = function () {
      $scope.schedulesGMB.push({
        date: new Date(),
        flag: false,
        description: ''
      })
    };

    $scope.requestNewSpecialHours = function () {
      $scope.schedulesGMB.forEach(el => {
        delete el.id;
        el.is_closed = !el.is_closed;
        el.start_hour = moment(el.start_hour).format('LT')
        el.end_hour = moment(el.end_hour).format('LT')
      })
      UnitDetail.requestNewSpecialHours($scope.schedulesGMB)
        .then(data => {
          Toast.success($filter('translate')('toast-success-request-new-special-hours'));
          $mdDialog.cancel();
        })
        .catch(err => {
          Toast.error($filter('translate')('toast-error-request-new-special-hours'));
          $mdDialog.cancel();
        });
    }

    $scope.hide = function () {
      angular.element(document.querySelector('#fileInput')).val(undefined);
      $mdDialog.hide();
    };

    $scope.saveHours = function () {
      let data = {
        name : $scope.eventName,
        special_hours : angular.copy($scope.schedulesGMB)
      }

      if($ctrl.id) {
        if(eventData) data.id = eventData.id
        saveEvent(angular.copy(data))
      }
      else {
        const dates = data.special_hours.map(date => {
          return date.date
        })
        const orderedDates = dates.sort(function(a, b) {
          return Date.parse(a) - Date.parse(b);
        });

        const event = {
          name : data.name,
          first_date : orderedDates[0],
          last_date: orderedDates[orderedDates.length - 1],
          days: data.special_hours.length,
          special_hours: angular.copy(data)
        }

        if((typeof idx) === 'number'){
          $ctrl.events[idx] = angular.copy(event)
        } else {
          $ctrl.events.push(angular.copy(event))
        }
      }
      $mdDialog.cancel();
    };

    $scope.cancel = function () {
      angular.element(document.querySelector('#fileInput')).val(undefined);
      $mdDialog.cancel();
    };

    $scope.cropImage = function (image_base64) {
      $mdDialog.hide(image_base64);
    }
  }

  function loadResource(id) {
    if (id) {
      Unit
        .show(id)
        .then(unit => {
          if (!unit.opening_hours.length) {
            unit.opening_hours.push(defaultUnitHour);
          }

          if (unit.city) {
            City
              .index({
                state_id: unit.city.state_id,
                limit: 10000
              })
              .then(cities => {
                $ctrl.cities = cities;
                $ctrl.unit = angular.copy(unit);
                formatUnitHours();
                $ctrl.uiState = 'COMPLETE';
              })
              .catch(err => {
                $ctrl.uiState = 'ERROR';
              });
          } else {
            $ctrl.unit = angular.copy(unit);
            formatUnitHours();
            $ctrl.uiState = 'COMPLETE';
          }
          $ctrl.locationSelected_id2 = $ctrl.newsItems.find(el => el.location_id === unit.gmb_id);
          $ctrl.unitRequest = {
            id: unit.id,
            address_complement: unit.address_complement,
            address_neighborhood: unit.address_neighborhood,
            address_number: unit.address_number,
            address_street: unit.address_street,
            address_postal_code: unit.address_postal_code,
            is_priority_special_hours: unit.is_priority_special_hours,
            is_schedule_available: unit.is_schedule_available,
            is_visible: unit.is_visible,
            is_visible_service_attendance: unit.is_visible_service_attendance,
            latitude: unit.latitude,
            longitude: unit.longitude,
            name: unit.name,
            observation: unit.observation,
            phone_number: unit.phone_number,
            terms: unit.terms,
            image_uri: unit.image_uri,
            deleted_at: unit.deleted_at,
            gmb_id: unit.gmb_id,
            created_at: unit.created_at,
            updated_at: unit.updated_at,
            region_id: unit.address_complement5,
            city_id: unit.address_complement882
          };
          $ctrl.hasNewsItem = unit.gmb_id ? true : false;

          $ctrl.prioritizeSpecialHour = unit.is_priority_special_hours === 1 ? true : false;
          getAttendanceHour($ctrl.unitRequest);
        })
        .catch(err => {
          $ctrl.uiState = 'ERROR';
        })
        .finally(()=>{
          loadSpecialHours(id)
        })
    } else {
      $ctrl.uiState = 'COMPLETE';
      $scope.$apply();
    }
  }

  $ctrl.formatDate = function (dateStr) {
    const dt = new Date(dateStr);
    const month = dt.getMonth() + 1
    return `${dt.getDate() < 10 ? '0'+dt.getDate() : dt.getDate()}/${month < 10 ? '0'+month : month}/${dt.getFullYear()}`
  };

  $ctrl.getDates = function (special_hours) {
    const dates = (special_hours.special_hours || special_hours).map(special_hour => {
      return $ctrl.formatDate(special_hour.date)
    })
    return dates
  }

  function formatUnitHours() {
    if ($ctrl.unit && $ctrl.unit.opening_hours.length) {
      const mapList = $ctrl.unit.opening_hours.map((item) => {
        const data = {
          id: item.id,
          name: item.name,
          schedule_title_id: item.schedule_title ? item.schedule_title.id : item.name,
          type: item.type,
          value: item.value
        };
        return data
      });
      $ctrl.unit.opening_hours = angular.copy(mapList)
    }
  }

  function loadSpecialHours(id){
    $ctrl.events = []
    Unit.getEvents(id)
    .then(data => {
      $ctrl.events = angular.copy(data)
    })
    .catch(err => {
      console.log(err)
    })
  }

  $ctrl.specialHour = {}

  $ctrl.editSpecialHour = function(id, idx, event){
    event.preventDefault();
    if(id){
      Unit.getEventDetail(id).
        then( resp => {
          $ctrl.specialHour = angular.copy(resp[0])
          toggleModalSpecialSchedules(event, angular.copy($ctrl.specialHour))
          $ctrl.editingSpecialHour = true;
        })
    }
    else if (idx.toString()){
      $ctrl.specialHour = angular.copy($ctrl.events[idx])
      toggleModalSpecialSchedules(event, angular.copy($ctrl.specialHour.special_hours), idx)
    }
  }

  function loadDomainResources() {
    $ctrl.uiState = 'LOADING';

    let promises = [];

    promises.push(Differential.index());
    promises.push(Region.index());
    promises.push(Service.index());
    promises.push(State.index());

    return Promise.all(promises);
  }

  function replaceSpecialChar(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  }

  async function requestChangeSchedule() {
    let schedules = []
    $ctrl.schedules.forEach(el => {
      schedules.push(Object.assign({}, el));
    });
    schedules.map(el => {
      if (el.id) {
        delete el.id;
      }
      el.is_open = el.is_open ? el.is_open : false;
      el.start_hour = moment(el.start_hour).format('LT');
      el.end_hour = moment(el.end_hour).format('LT');
      el.change_reason = $ctrl.requestChangeScheduleObservation;
    })
    $ctrl.changeScheduleLoading = true;
    await UnitDetail.requestChangeSchedule(schedules)
      .then(response => {
        Toast.success($filter('translate')('toast-success-request-change-schedule'));
      })
      .catch(err => {
        Toast.error($filter('translate')('toast-error-request-change-schedule'));
      });
    $ctrl.requestChangeScheduleObservation = null;
    setTimeout(() => {
      document.querySelectorAll('.md-input-invalid')[0].classList.remove('md-input-invalid')
    }, 500)
    $ctrl.changeScheduleLoading = false;
  }

  $ctrl.toggleModalSpecialSchedules = (event) => {
    $mdDialog.show({
      controller: DialogController,
      targetEvent: event,
      template: modalSpecialSchedules,
      bindToController: true,
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      fullscreen: false
    })
      .then(function (image_base64) {
        $ctrl.unit.image_base64 = image_base64;
        $ctrl.myImage = '';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
  }

  function toggleModalSpecialSchedules(event, eventData, idx = null) {
    $ctrl.editingSpecialHour = false
    if(eventData && eventData.special_hours.length > 0) {
      eventData.special_hours.forEach(dateEvent => {
        dateEvent.date = new Date(dateEvent.date)
      })
    }
    $mdDialog.show({
      controller: DialogController,
      targetEvent: event,
      template: modalSpecialSchedules,
      bindToController: true,
      parent: angular.element(document.body),
      clickOutsideToClose: false,
      locals: {
        eventData: angular.copy(eventData),
        idx: idx
      },
      fullscreen: false
    })
      .then(function (image_base64) {
        $ctrl.unit.image_base64 = image_base64;
        $ctrl.myImage = '';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
  }

  function toggleModalApprovalSpecialSchedules(event) {
    $mdDialog.show({
      controller: DialogController,
      targetEvent: event,
      template: modalApprovalSpecialSchedules,
      bindToController: true,
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      fullscreen: false
    })
      .then(function (image_base64) {
        $ctrl.unit.image_base64 = image_base64;
        $ctrl.myImage = '';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
  }

  function getTimeTitleList() {
    $ctrl.promise = TimeTitleService.getTimeTitleList()
    .then((response) => {
      response.data.forEach(item => $ctrl.scheduleTitles.push(item))
    })
  }
}

UnitDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'City', 'Differential', 'NgMap', 'Region', 'Service', 'State', 'Toast', 'Unit', 'UnitDetail', 'TimeTitleService'];

export default UnitDetailController;



// WEBPACK FOOTER //
// ./client/app/components/unit/unit-detail.controller.js